import React from 'react';

/**
 * Marks a control that is drawn but not wired.
 *
 * Three blocks of this screen have no backend at all: there is no two-factor
 * enrolment, no session listing and no account deletion anywhere in the API.
 * They stay visible by decision, so each one has to say plainly that it does
 * nothing yet — a button that looks live and answers nothing is worse than an
 * absent feature.
 */
export const SoonPill = () => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-ninja-gray dark:bg-[#2d2d2d] border border-border text-[10px] font-bold uppercase tracking-wider text-text-muted">
    Pronto
  </span>
);
